<section class="content">
  <div class="hgx-page">
    <div class="hgx-page-header">
      <div>
        <h1>Planning</h1>
        <p>Toutes les chambres et tous les espaces, toutes formules confondues</p>
      </div>
    </div>

    <div class="hgx-panel">
      <div class="hgx-tab-body">
        <app-disponibilite-calendrier mode="tout" [actualisationAuto]="actualisation" [creation]="true"></app-disponibilite-calendrier>
      </div>
    </div>
  </div>
</section>
